module.exports = __webpack_public_path__ + "static/img/things.355155e7.png";